export default import.meta.ROLLDOWN_FILE_URL_J$gv7yiEKpnkgFNmpH4S5A